import { __exports as d } from "../../../../_virtual/Modal.js";
import N from "react";
import T from "react-dom";
import x from "prop-types";
import { M as A } from "./ModalPortal.js";
import "../helpers/ariaAppHider.js";
import "../helpers/safeHTMLElement.js";
import D from "../../../../_virtual/react-lifecycles-compat.es.js";
import { __exports as w } from "../../../../_virtual/safeHTMLElement.js";
import { __exports as q } from "../../../../_virtual/ariaAppHider.js";
Object.defineProperty(d, "__esModule", {
  value: !0
});
d.bodyOpenClassName = d.portalClassName = void 0;
var g = Object.assign || function(r) {
  for (var e = 1; e < arguments.length; e++) {
    var o = arguments[e];
    for (var a in o)
      Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
  }
  return r;
}, H = /* @__PURE__ */ function() {
  function r(e, o) {
    for (var a = 0; a < o.length; a++) {
      var n = o[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  return function(e, o, a) {
    return o && r(e.prototype, o), a && r(e, a), e;
  };
}(), R = N, O = m(R), U = T, _ = m(U), L = x, t = m(L), k = A, C = m(k), $ = q, W = B($), u = w, M = m(u), F = D;
function B(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  return e.default = r, e;
}
function m(r) {
  return r && r.__esModule ? r : { default: r };
}
function j(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function P(r, e) {
  if (!r)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : r;
}
function I(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(r, e) : r.__proto__ = e);
}
var V = d.portalClassName = "ReactModalPortal", z = d.bodyOpenClassName = "ReactModal__Body--open", s = u.canUseDOM && _.default.createPortal !== void 0, b = function(e) {
  return document.createElement(e);
}, E = function() {
  return s ? _.default.createPortal : _.default.unstable_renderSubtreeIntoContainer;
};
function y(r) {
  return r();
}
var p = function(r) {
  I(e, r);
  function e() {
    var o, a, n, l;
    j(this, e);
    for (var c = arguments.length, v = Array(c), f = 0; f < c; f++)
      v[f] = arguments[f];
    return l = (a = (n = P(this, (o = e.__proto__ || Object.getPrototypeOf(e)).call.apply(o, [this].concat(v))), n), n.removePortal = function() {
      !s && _.default.unmountComponentAtNode(n.node);
      var i = y(n.props.parentSelector);
      i && i.contains(n.node) ? i.removeChild(n.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, n.portalRef = function(i) {
      n.portal = i;
    }, n.renderPortal = function(i) {
      var h = E(), S = h(n, O.default.createElement(C.default, g({ defaultStyles: e.defaultStyles }, i)), n.node);
      n.portalRef(S);
    }, a), P(n, l);
  }
  return H(e, [{
    key: "componentDidMount",
    value: function() {
      if (u.canUseDOM) {
        s || (this.node = b("div")), this.node.className = this.props.portalClassName;
        var a = y(this.props.parentSelector);
        a.appendChild(this.node), !s && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(a) {
      var n = y(a.parentSelector), l = y(this.props.parentSelector);
      return { prevParent: n, nextParent: l };
    }
  }, {
    key: "componentDidUpdate",
    value: function(a, n, l) {
      if (u.canUseDOM) {
        var c = this.props, v = c.isOpen, f = c.portalClassName;
        a.portalClassName !== f && (this.node.className = f);
        var i = l.prevParent, h = l.nextParent;
        h !== i && (i.removeChild(this.node), h.appendChild(this.node)), !(!a.isOpen && !v) && !s && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!u.canUseDOM || !this.node || !this.portal)) {
        var a = this.portal.state, n = Date.now(), l = a.isOpen && this.props.closeTimeoutMS && (a.closesAt || n + this.props.closeTimeoutMS);
        l ? (a.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, l - n)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!u.canUseDOM || !s)
        return null;
      !this.node && s && (this.node = b("div"));
      var a = E();
      return a(O.default.createElement(C.default, g({
        ref: this.portalRef,
        defaultStyles: e.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(a) {
      W.setElement(a);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), e;
}(R.Component);
p.propTypes = {
  isOpen: t.default.bool.isRequired,
  style: t.default.shape({
    content: t.default.object,
    overlay: t.default.object
  }),
  portalClassName: t.default.string,
  bodyOpenClassName: t.default.string,
  htmlOpenClassName: t.default.string,
  className: t.default.oneOfType([t.default.string, t.default.shape({
    base: t.default.string.isRequired,
    afterOpen: t.default.string.isRequired,
    beforeClose: t.default.string.isRequired
  })]),
  overlayClassName: t.default.oneOfType([t.default.string, t.default.shape({
    base: t.default.string.isRequired,
    afterOpen: t.default.string.isRequired,
    beforeClose: t.default.string.isRequired
  })]),
  appElement: t.default.oneOfType([t.default.instanceOf(M.default), t.default.instanceOf(u.SafeHTMLCollection), t.default.instanceOf(u.SafeNodeList), t.default.arrayOf(t.default.instanceOf(M.default))]),
  onAfterOpen: t.default.func,
  onRequestClose: t.default.func,
  closeTimeoutMS: t.default.number,
  ariaHideApp: t.default.bool,
  shouldFocusAfterRender: t.default.bool,
  shouldCloseOnOverlayClick: t.default.bool,
  shouldReturnFocusAfterClose: t.default.bool,
  preventScroll: t.default.bool,
  parentSelector: t.default.func,
  aria: t.default.object,
  data: t.default.object,
  role: t.default.string,
  contentLabel: t.default.string,
  shouldCloseOnEsc: t.default.bool,
  overlayRef: t.default.func,
  contentRef: t.default.func,
  id: t.default.string,
  overlayElement: t.default.func,
  contentElement: t.default.func
};
p.defaultProps = {
  isOpen: !1,
  portalClassName: V,
  bodyOpenClassName: z,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(e, o) {
    return O.default.createElement(
      "div",
      e,
      o
    );
  },
  contentElement: function(e, o) {
    return O.default.createElement(
      "div",
      e,
      o
    );
  }
};
p.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, F.polyfill)(p);
process.env.NODE_ENV !== "production" && (p.setCreateHTMLElement = function(r) {
  return b = r;
});
d.default = p;
